module.exports = __webpack_public_path__ + "infocentrum18.jpg?f55db1f335ecbbfb49e17d62edc3de5c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/infocentrum/infocentrum18.jpg
// module id = 270
// module chunks = 0